<template>
  <div class="filter-box filter--btn">
    <div class="icon-btn filter-icon-btn" @click="handleOnOpenFilter" id="filter-btn">
      <FIcon name="filter" size="1.4rem" />
    </div>
  </div>
</template>

<script>
import AppFiltersOptionsList from "../options";

const FilterBtn = {
  name: "FilterBtn",

  data() {
    return {
      show: false,
      toggleAllFilters: true,
    };
  },

  props: {
    headers: {
      type: Array,
    },
    modelName: {
      type: String,
    },
    handleOnOpenFilter: {
      type: Function,
    },
  },

  methods: {
    /**
     * Select all locations
     * @return {void}
     */
    handleOnSelectAll(value) {
      this.locations.forEach((item, index) => (item.selected = value));
    },

    handleOnSearchUpdates() {
      this.doSearchBounce();
    },
  },
};

export default FilterBtn;
</script>
